export default "__VITE_ASSET__DIchyWww__"